module.exports = __webpack_public_path__ + "static/img/jay_1000.2beec87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/jay_1000.jpg
// module id = JbWP
// module chunks = 1